export const FIND_STORY = 'FIND_STORY';
export const GO_TO_STORY = 'GO_TO_STORY';
export const OPEN_STORY = 'OPEN_STORY';
export const START_OVER = 'START_OVER';
export const START_TRIP = 'START_TRIP';

export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME';
export const SET_VIDEO_DURATION = 'SET_VIDEO_DURATION';
export const SEEK_VIDEO = 'SEEK_VIDEO';

export const START_DRIVING = 'START_DRIVING';
export const PAUSE_DRIVING = 'PAUSE_DRIVING';
export const OPEN_MENU = 'OPEN_MENU';

export const MUTE_AUDIO = 'MUTE_AUDIO';

export const SET_LANGUAGE = 'SET_LANGUAGE';

export function updateCurrentTime (time) {
    return dispatch => {
        dispatch({
            payload: time,
            type: FIND_STORY,
        });
        dispatch({
            payload: time,
            type: UPDATE_CURRENT_TIME,
        });
    };
}

export function setVideoDuration (time) {
    return {
        payload: time,
        type: SET_VIDEO_DURATION,
    };
}

export function openStory () {
    return {
        type: OPEN_STORY,
        payload: true,
    };
}

export function closeStory () {
    return {
        type: OPEN_STORY,
        payload: false
    };
}

export function startTrip () {
    return {
        type: START_TRIP
    };
}

export function startOver () {
    return {
        type: START_OVER
    };
}

export function goToStory (story) {
    return dispatch => {
        dispatch({
            payload: story.time,
            type: SEEK_VIDEO,
        });
        dispatch({
            payload: story,
            type: GO_TO_STORY,
        });
    };
}

export function goToStoryBySlug (slug, open = true) {
    return (dispatch, getState) => {
        const {timeline} = getState();

        const story = timeline.data.find((story) => {
            return story.type === "story" && story.link.url.split('/').pop() === slug;
        });

        if (story) {
            if (timeline.tripStarted === false) dispatch(startTrip());
            dispatch(goToStory(story));
            if (open) dispatch(openStory());
        } else {
            dispatch(closeStory());
        }

    }
}

export function setSeekVideo (time) {
    return {
        payload: time,
        type: SEEK_VIDEO,
    };
}

export function startDriving () {
    return {
        type: START_DRIVING
    };
}

export function pauseDriving () {
    return {
        type: PAUSE_DRIVING
    };
}

export function openMenu (openOrClose) {
    return {
        payload: openOrClose,
        type: OPEN_MENU
    };
}

export function muteAudio (onOrOff) {
    return {
        payload: onOrOff,
        type: MUTE_AUDIO
    };
}

export function setLanguage (language) {
    return (dispatch, getState) => {
        const {timeline} = getState();

        const videoCurrentTime = timeline.currentTime;

        dispatch({
            payload: language,
            type: SET_LANGUAGE,
        });

        if (videoCurrentTime) dispatch(setSeekVideo(videoCurrentTime))

    };
}


// WEBPACK FOOTER //
// ./src/state/actions/timeline.js